import {PATH_CAMERA_SNAPSHOTS_BY_TIME} from "@constants/navigate";
import {serialize} from "@helpers/query/serialize";

export const buildLinkLinkToSnapshotsByTime = ({
												   dateTo,
												   dateFrom,
												   deviceId,
												   accountId,
											   }: {
												   dateFrom?: string
												   dateTo?: string
												   deviceId: number
												   accountId: number
											   }
): string => {
	return `${PATH_CAMERA_SNAPSHOTS_BY_TIME}?` + serialize({
		deviceId,
		accountId,
		...(dateFrom ? {dateFrom} : {}),
		...(dateTo ? {dateTo} : {}),
	})
}